import {createReducer, on} from '@ngrx/store';
import {datevWizardGetFirmaStateInitial} from './datev-wizard-get-firma.state.initial';
import {DatevWizardGetFirmaActions} from './datev-wizard-get-firma.actions';
import {DatevWizardGetFirmaState} from './datev-wizard-get-firma.state';


export const datevWizardGetFirmaReducers = createReducer(
  datevWizardGetFirmaStateInitial,

  on(
    DatevWizardGetFirmaActions.setFirma,
    (state, {firmenId}): DatevWizardGetFirmaState => ({
      ...state,
      firmenId,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.syncFirmaFromRoute,
    (state, {firmenId}): DatevWizardGetFirmaState => ({
      ...state,
      firmenId,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.setFirmenUsedInThePast,
    (state, {firmenUsedInThePast}): DatevWizardGetFirmaState => ({
      ...state,
      firmenUsedInThePast,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.addInvalidFirma,
    (state, {firmenId}): DatevWizardGetFirmaState => ({
      ...state,
      invalidFirmenIds: state.invalidFirmenIds.includes(firmenId) ? state.invalidFirmenIds : [...state.invalidFirmenIds, firmenId],
    }),
  ),

  on(
    DatevWizardGetFirmaActions.selectIdentifierType,
    (state, {identifierType}): DatevWizardGetFirmaState => ({
      ...state,
      selectedIdentifierType: identifierType,
      searchResults: undefined,
      searchError: undefined,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.searchFirmaByBetriebsnummer,
    DatevWizardGetFirmaActions.searchFirmaByFirmennummer,
    DatevWizardGetFirmaActions.searchFirmaByPartnernummer,
    (state): DatevWizardGetFirmaState => ({
      ...state,
      isSearching: true,
      searchError: undefined,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.searchFirmaSuccess,
    (state, {results}): DatevWizardGetFirmaState => ({
      ...state,
      isSearching: false,
      searchResults: results,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.searchFirmaFailure,
    (state, {error}): DatevWizardGetFirmaState => ({
      ...state,
      isSearching: false,
      searchError: error,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.selectFirmaFromSearchResults,
    (state, {firma}): DatevWizardGetFirmaState => ({
      ...state,
      firmenId: firma.id,
      searchResults: undefined,
    }),
  ),

  on(
    DatevWizardGetFirmaActions.clearSearchResults,
    (state): DatevWizardGetFirmaState => ({
      ...state,
      searchResults: undefined,
      searchError: undefined,
    }),
  ),
);
